import React from 'react'
const IconErr500 = () => {
  return (
    <>
      <svg
        fill='none'
        height='398'
        viewBox='0 0 408 398'
        width='408'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='true'>
        <linearGradient id='a' gradientUnits='userSpaceOnUse' x1='288.864' x2='280.704' y1='229.033' y2='280.715'>
          <stop offset='0' stopColor='#054ba2' />
          <stop offset='1' stopColor='#fff' stopOpacity='0' />
        </linearGradient>
        <linearGradient id='b' gradientUnits='userSpaceOnUse' x1='321.83' x2='321.83' y1='128.934' y2='223.2'>
          <stop offset='0' stopColor='#002b94' />
          <stop offset='.302626' stopColor='#1960b0' />
          <stop offset='.639149' stopColor='#fff' />
        </linearGradient>
        <linearGradient id='c' gradientUnits='userSpaceOnUse' x1='172.992' x2='202.913' y1='110.436' y2='132.739'>
          <stop offset='0' stopColor='#dac292' />
          <stop offset='1' stopColor='#fff' />
        </linearGradient>
        <linearGradient id='d' gradientUnits='userSpaceOnUse' x1='308.448' x2='298.111' y1='129.478' y2='219.242'>
          <stop offset='0' stopColor='#fff' />
          <stop offset='.40625' stopColor='#f1e0c4' />
          <stop offset='.96875' stopColor='#fff' />
        </linearGradient>
        <linearGradient id='e' gradientUnits='userSpaceOnUse' x1='210.926' x2='12.9077' y1='251.832' y2='343.909'>
          <stop offset='0' stopColor='#3f77bc' />
          <stop offset='.220494' stopColor='#feffff' stopOpacity='0' />
          <stop offset='.765625' stopColor='#fff' stopOpacity='.612069' />
          <stop offset='1' stopColor='#2d69b4' />
        </linearGradient>
        <path
          d='m233.376 246.986 2.176-17.409 11.968-7.072 1.632 2.176 4.896 4.896c2.358 1.088 8.378 3.482 13.6 4.353 6.528 1.088 15.776-1.088 20.672-3.265 3.917-1.74 10.699-6.166 13.6-8.16h8.704l7.072-1.632 4.352 14.689 8.704 19.584 4.896 11.425-52.224 10.336-1.632-1.632-2.176-15.776-2.176-11.425-.544 3.808-1.632 8.705-3.808 11.424-3.264 8.704-25.024-5.44-17.408-6.528 4.896-10.88z'
          fill='url(#a)'
        />
        <path
          d='m327.488 151.239c-.435-9.14-3.082-18.679-4.352-22.305l4.896 2.72c2.358 2.357 7.507 8.378 9.248 13.6 2.176 6.529 3.264 13.057 3.808 20.129s-1.088 18.497-2.176 24.481-6.528 17.953-8.16 20.129c-1.306 1.741-7.072 6.528-9.792 8.704-2.176 1.27-7.29 3.917-10.336 4.352-3.047.436-6.71-.181-8.16-.544l4.352-4.896c3.264-3.264 10.989-12.948 15.776-25.569 5.984-15.776 5.44-29.377 4.896-40.801z'
          fill='url(#b)'
        />
        <path
          d='m164.832 137.637 4.352 9.248 34.272.544 46.784-33.729c-.182-2.357-.762-7.725-1.632-10.336-1.088-3.265-2.176-4.8967-4.896-9.2489-2.176-3.4817-6.71-6.1655-8.704-7.0723-2.358-1.2693-8.813-3.9169-15.776-4.3521-8.704-.5441-9.792 1.632-12.512 3.2641-2.176 1.3057-3.082 3.8082-3.264 4.8962-.726.1813-2.829.6528-5.44 1.088-3.264.5441-4.896 2.1761-6.528 3.8082-1.306 1.3057-1.994 4.1708-2.176 5.4398-.906.363-3.155 1.197-4.896 1.632-1.741.436-4.352 3.083-5.44 4.353l-1.088 4.352c-2.358-.181-7.943.326-11.424 3.808-3.482 3.482-3.626 8.704-3.264 10.88z'
          fill='url(#c)'
        />
        <path
          d='m270.368 233.93c-13.927-.87-20.672-7.254-22.304-10.336l-2.72-72.355-5.44-16.865 32.64-17.408 3.808-3.264 5.44-2.721 7.072-.544c.544-.544 2.176-1.958 4.352-3.264 2.72-1.632 8.704-1.632 12.512 0s8.704 5.44 11.424 8.161c2.176 2.176 3.808 5.984 4.352 7.616l1.632 6.528 3.808 20.673.544 12.513-.544 9.792-2.72 14.145-4.896 12.512-4.896 9.248-10.88 12.513c-5.258 4.714-19.258 13.927-33.184 13.056z'
          fill='url(#d)'
        />
        <path
          d='m170.073 147.536s8.922 2.289 12.658 9.053 7.762 16.016 7.762 16.016l2.414 11.552 1.334 9.426.476 10.204-1.044 12.413-2.438 8.938-4.269 7.333 21.477-11.714-6.393-18.085-2.912-17.294.846-17.283 2.136-9.309 4.525-8.206 4.431-3.033 17.428-9.507 34.622-18.886-4.13-6.392-3.55-4.44-2.855-2.441-3.667-1.418.535 5.753s-1.369 3.777-2.751 4.626c-1.38.848-2.54 1.696-4.257 1.813-1.718.116-6.231-.965-6.231-.965s-.313 4.184-1.16 5.405c-.847 1.22-4.444 3.474-4.444 3.474l-4.851.221-1.485-.43-.254 5.277-3.04 4.067-3.923 1.558-4.107-.593-2.437-.697-.046 4.637s.093 3.162-2.099 4.568c-2.194 1.407-4.908 2.65-6.602 2.371s-7.345-3.382-7.345-3.382l-6.486-3.021s-4.467.115-5.326.696c-.858.582-12.333 6.834-12.333 6.834z'
          fill='#000'
        />
        <path
          d='m213.362 147.524 5.686 2.232 5.929 6.474 4.258 7.728 3.005 7.753 3.052 9.681 1.114 9.17.719 8.403.359 8.264-1.426 9.646-2.193 7.95-3.782 6.566 35.272-18.421 5.86-14.087 1.415-10.389-1.034-6.695-4.083-10.798-5.917-9.367-4.677-4.021-8.261-6.079-4.537-4.858-2.042-5.172v-3.068l2.275-4.766 3.214-2.301 4.605-1.429 4.967.511 1.821-4.394 3.342-4.136 5.569-1.221 5.813.488.697-4.428 1.032-2.127-3.365-.43-54.51 29.648z'
          fill='#000'
        />
        <path
          d='m182.082 234.619c9.873-1.44 15.042-22.093 11.545-46.126-3.497-24.034-14.334-42.349-24.207-40.908-9.872 1.441-15.041 22.093-11.544 46.127 3.496 24.034 14.334 42.349 24.206 40.907z'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m224.57 234.619c9.872-1.44 15.041-22.093 11.545-46.126-3.497-24.034-14.335-42.349-24.207-40.908-9.873 1.441-15.042 22.093-11.545 46.127s14.334 42.349 24.207 40.907z'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m262.72 119.361c-3.283-6.926-7.216-11.97-11.254-14.19 0 0-1.775-.988-2.529-.639'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m184.146 234.017 24.308-13.261'
          stroke='#000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m210.044 148.103 48.395-26.405 11.348-6.194s2.448-1.524 5.639-.559'
          stroke='#000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m221.511 213.597c5.104-.745 7.777-11.42 5.97-23.843-1.808-12.425-7.41-21.892-12.515-21.146-5.104.745-7.777 11.42-5.97 23.844 1.808 12.423 7.41 21.89 12.515 21.145z'
          fill='#000'
        />
        <path
          d='m179.024 213.599c5.105-.745 7.777-11.42 5.97-23.843-1.807-12.425-7.411-21.892-12.516-21.146-5.103.745-7.777 11.42-5.968 23.843 1.807 12.424 7.41 21.891 12.514 21.146z'
          fill='#000'
        />
        <path
          d='m189.496 101.138.186-1.2321s1.252-11.0644 20.025-8.5308c12.81 2.5569 19.389 8.9259 22.928 14.6439 2.204 3.487 5.441 13.18 1.102 16.713-4.351 3.533-8.296 2.093-8.296 2.093l-1.462-.651'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m235.675 229.158s-2.263 26.428-9.306 38.365c-7.042 11.936-17.938 20.595-24.284 22.628-6.335 2.035-26.327 4.824-26.327 4.824s-17.834 1.464-17.834 10.542c0 6.566 12.102 6.427 17.834 6.253 5.731-.176 36.862-1.221 36.862-1.221s9.921-.524 13.737-8.356c3.829-7.834 3.482 7.495 3.482 7.495l28.345-.522 11.753-32.38s7.531-18.782 7.531-32.125l4.362 31.415s37.291 2.743 54.952-7.205c-5.756-11.041-11.453-25.034-16.012-37.191l-3.435-10.914'
          stroke='#000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m225.974 268.289c-7.042 11.936-17.555 20.014-23.889 22.048-6.335 2.034-26.327 4.823-26.327 4.823s-17.834 1.465-17.834 10.541c0 6.567 12.102 6.428 17.834 6.253 5.731-.174 36.862-1.22 36.862-1.22s9.921-.523 13.737-8.357c3.829-7.844 3.482 7.497 3.482 7.497l28.344-.523s8.935-24.558 10.571-29.265c-28.914-2.453-42.78-11.797-42.78-11.797z'
          fill='#000'
        />
        <g strokeWidth='1.5'>
          <path
            d='m268.754 280.075c-5.766-.489-30.365-4.254-42.385-11.216'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m258.532 109.796c-.824-7.892 4.189-13.9005 4.189-13.9005 4.351-4.7651 12.009-10.4136 24.052-10.8088 21.071-.6858 29.448 10.495 31.711 19.0023.174.663.313 1.302.406 1.918.231 1.406.266 2.661.174 3.789l.047 6.183'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m257.72 130.077c-.012-2.999 1.741-5.149 1.741-5.149s4.13-8.194 20.199-1.917c16.07 6.276 17.59 24.988 17.59 24.988'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m281.645 157.809s-1.52-18.711-17.59-24.988c-16.07-6.276-20.201 1.918-20.201 1.918s-1.751 2.162-1.739 5.149c0 0-.349 5.044 3.793 9.24 1.822 1.847 6.324 5.509 9.12 7.241 4.572 2.847 6.996 5.59 9.943 10.099 6.428 9.867 7.635 18.248 7.496 24.652-.185 8.112-7.113 21.85-7.113 21.85'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m273.685 120.094c-.012-2.997 1.741-5.148 1.741-5.148s4.13-8.194 20.2-1.917c16.069 6.275 17.589 24.988 17.589 24.988'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path d='m226.369 234.237 38.985-21.28' stroke='#000' strokeLinecap='round' strokeMiterlimit='10' />
          <path
            d='m278.605 93.6764s-1.706-15.4809 12.612-13.1333c3.841.6276 6.022 5.2998 6.022 5.2998'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m286.205 93.8614s1.055-17.7241 14.388-11.9361c3.12 1.3598 5.209 6.3458 5.209 6.3458'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m230.21 124.348s-4.966-11.227-4.746-15.341c.163-3.022 1.88-5.23 4.746-5.544'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m218.608 134.482s-4.967-11.228-4.746-15.342c.162-3.022 1.88-5.23 4.746-5.544'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m169.434 147.593s-3.712-5.161-5.105-12.331c-1.392-7.171-1.404-9.507-.778-13.506.383-2.138 2.032-12.47 20.816-9.937 12.81 2.557 19.388 8.926 22.927 14.645 2.205 3.486 5.441 13.179 1.102 16.712-4.35 3.533-8.296 2.093-8.296 2.093s-2.947-1.512-9.248-5.045c-3.456-1.941-7.344-.755-7.344-.755l-17.694 9.658'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m204.846 144.78s-4.966-11.227-4.746-15.342c.163-3.021 1.88-5.229 4.746-5.543'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m203.268 91.5504s1.253-11.0644 20.026-8.5308c12.809 2.5569 19.389 8.926 22.928 14.6442 2.204 3.4872 5.441 13.1802 1.102 16.7122-4.34 3.534-8.296 2.093-8.296 2.093l-3.144-.895'
            stroke='#000'
            strokeMiterlimit='10'
          />
          <path
            d='m243.797 115.979s-4.967-11.227-4.746-15.341c.162-3.0222 1.88-5.2305 4.746-5.5442'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m177.765 111.435.313-1.395s1.254-11.0638 20.027-8.53c12.809 2.557 19.388 8.925 22.927 14.644 2.205 3.487 5.442 13.18 1.103 16.712-4.352 3.534-8.296 2.093-8.296 2.093s-3.284-.872-3.748-1.197'
            stroke='#000'
            strokeMiterlimit='10'
          />
          <path
            d='m243.854 134.739s3.968 3.521 8.389 1.942c4.422-1.581 6.184-4.441 6.184-4.441'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m260.203 124.416s3.968 3.522 8.389 1.941 6.184-4.439 6.184-4.439'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m276.377 114.909s3.968 3.522 8.388 1.941c4.433-1.58 6.186-4.44 6.186-4.44'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m247.568 222.671s5.545 10.426 22.416 11.344c16.87.919 31.373-11.344 31.373-11.344s39.172-27.567 21.965-93.013c-1.207-7.426-4.2-13.679-11.011-18.991-7.588-5.207-13.436-4.893-17.173-4.207-3.271.592-5.429 2.115-6.137 4.103'
            stroke='#000'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m301.347 222.672s31.199 6.521 38.301-36.576c7.542-45.711-15.607-57.391-15.607-57.391'
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
          <path
            d='m223.783 229.376c7.4-1.081 10.901-19.123 7.82-40.298-3.081-21.176-11.577-37.467-18.976-36.387-7.4 1.081-10.901 19.123-7.821 40.298 3.081 21.176 11.578 37.467 18.977 36.387z'
            stroke='#000'
            strokeMiterlimit='10'
          />
          <path
            d='m180.553 229.374c7.4-1.081 10.901-19.123 7.82-40.298-3.081-21.176-11.576-37.466-18.977-36.387-7.399 1.081-10.9 19.123-7.819 40.298 3.08 21.177 11.576 37.467 18.976 36.387z'
            stroke='#000'
            strokeMiterlimit='10'
          />
          <path
            d='m209.603 150.475 58.85-36.889'
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
        </g>
        <path
          d='m151.365 249.285c-64.6126 5.827-111.1091 22.086-111.1091 41.223 0 24.039 73.3101 43.522 163.7411 43.522 90.43 0 163.74-19.483 163.74-43.522 0-19.146-46.495-35.396-111.107-41.223'
          fill='#fff'
        />
        <path
          d='m151.365 249.285c-64.6126 5.827-111.1091 22.086-111.1091 41.223 0 24.039 73.3101 43.522 163.7411 43.522 90.43 0 163.74-19.483 163.74-43.522 0-19.146-46.495-35.396-111.107-41.223'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m203.997 314.988c63.725 0 115.384-12.684 115.384-28.332 0-15.647-51.659-28.332-115.384-28.332-63.726 0-115.3847 12.685-115.3847 28.332 0 15.648 51.6587 28.332 115.3847 28.332z'
          fill='#fff'
          stroke='#000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path d='m256.615 249.285c-16.518-1.49-34.224-2.299-52.632-2.299s-36.114.809-52.633 2.299' fill='#fff' />
        <path
          d='m256.615 249.285c-16.518-1.49-34.224-2.299-52.632-2.299s-36.114.809-52.633 2.299'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m308.437 299.211c1.071-1.474 1.643-3.002 1.643-4.56 0-14.306-47.493-25.905-106.08-25.905s-106.0801 11.599-106.0801 25.905c0 1.558.0023 1.987 1.088 3.472'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m219.296 268.037s5.14 26.68-26.391 34.132c-15.071 1.75-24.79-3.107-29.953-6.999l-4.177-3.528-132.4283 32.85.7509-5.746'
          fill='#fff'
        />
        <path
          d='m219.296 268.037s5.14 26.68-26.391 34.132c-15.071 1.75-24.79-3.107-29.953-6.999l-4.177-3.528-132.4283 32.85.7509-5.746'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m151.175 278.827-129.1242 32.766 5.0322 7.152 127.261-31.725s12.188 14.773 43.403 5.213c26.088-7.498 22.957-22.875 20.15-27.049-1.479-2.585-10.584-14.845-38.252-9.043-27.659 5.286-28.483 22.669-28.483 22.669z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path d='m21.3788 311.195-.8734 6.233 5.4387 7.884' fill='#fff' />
        <path d='m21.3788 311.195-.8734 6.233 5.4387 7.884' stroke='#000' strokeMiterlimit='10' strokeWidth='1.5' />
        <path
          d='m219.296 268.037s5.14 26.68-26.391 34.132c-15.071 1.75-24.79-3.107-29.953-6.999l-4.177-3.528-132.4283 32.85.7509-5.746'
          fill='#fff'
        />
        <path
          d='m219.296 268.037s5.14 26.68-26.391 34.132c-15.071 1.75-24.79-3.107-29.953-6.999l-4.177-3.528-132.4283 32.85.7509-5.746'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m151.175 278.827-129.1242 32.766 5.0322 7.152 127.261-31.725s12.188 14.773 43.403 5.213c26.088-7.498 22.957-22.875 20.15-27.049-1.479-2.585-10.584-14.845-38.252-9.043-27.659 5.286-28.483 22.669-28.483 22.669z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m20.75 317.507.7048-5.395c41.6472-6.628 125.9552-22.604 130.0112-33.486 5.069-13.603 10.627-18.362 30.424-22.908 19.796-4.546 31.966 3.079 36.046 9.648 3.263 5.254 1.435 12.806.113 15.925-1.314 5.864-8.091 18.256-24.678 20.916-16.586 2.661-29.769-5.902-34.286-10.515l-133.7161 32.454z'
          fill='url(#e)'
        />
        <path d='m21.3793 311.195-.8734 6.233 5.4387 7.884' stroke='#000' strokeMiterlimit='10' strokeWidth='1.5' />
        <path
          d='m219.296 268.037s5.14 26.68-26.391 34.132c-15.071 1.75-24.79-3.107-29.953-6.999l-4.177-3.528-132.4283 32.85.7509-5.746'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m151.175 278.827-129.1242 32.766 5.0322 7.152 127.261-31.725s12.188 14.773 43.403 5.213c26.088-7.498 22.957-22.875 20.15-27.049-1.479-2.585-10.584-14.845-38.252-9.043-27.659 5.286-28.483 22.669-28.483 22.669z'
          stroke='#000'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <path
          d='m189.157 295.355c-1.259-1.434-2.021-3.321-2.021-5.371 0-4.522 3.661-8.181 8.186-8.181s8.581 3.659 8.581 8.181'
          fill='#000'
        />
        <path
          d='m189.157 295.355c-1.259-1.434-2.021-3.321-2.021-5.371 0-4.522 3.661-8.181 8.186-8.181s8.581 3.659 8.581 8.181'
          stroke='#000'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
      </svg>
    </>
  )
}
export default IconErr500
